module.exports = __webpack_public_path__ + "371e114ae28e6f8c180dfad2f0b1ec7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-34.jpg
// module id = 1176
// module chunks = 0